module.exports = __webpack_public_path__ + "static/media/silver-box.6f20c589.png";